import { Component, OnInit, Injector } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { SecondPageEditBase } from 'vnpost-shared';
import { TypeCustomerService } from '../../services/type-customer.service';


@Component({
  selector: 'app-edit-type-customer',
  templateUrl: './edit-type-customer.component.html',
  styleUrls: ['./edit-type-customer.component.css']
})
export class EditTypeCustomerComponent extends SecondPageEditBase
implements OnInit
{
listStatus: { label: string; value: number }[] = [
  { label: 'Đang áp dụng', value: 1 },
  { label: 'Ngừng áp dụng', value: 0 },
];
isDisable: any;

constructor(
  protected _service: TypeCustomerService,
  protected _injector: Injector
) {
  super(_service, _injector);
  this.formGroup = new UntypedFormGroup({
    customerCode: new UntypedFormControl('', [Validators.required]),
    customerName: new UntypedFormControl(''),
    status: new UntypedFormControl(''),
    notes: new UntypedFormControl(''),
  });
}

ngOnInit() {}

onShowPopup(model: any) {
  this.isDisable = model.isDisable;
  this.validationSummary.resetErrorMessages();
  this.resetForm();

  if (model.id > 0) {
    this._service.getTypeCustomerDetail(model.id).then(
      (rs) => {
        this.itemDetail = rs.data;
      },
      (error) => {
        this._notifierService.showWarning(
          this._translateService.instant('MESSAGE.NOT_FOUND_ERROR')
        );
      }
    );
  }
}

async save() {
  this.submitting = true;

  if (this.formGroup.invalid) {
    this.submitting = false;
    this.validationSummary.showValidationSummary();
    return;
  }

  this.onUpdate();
}

onUpdate() {
  this._service.update(this.itemDetail.id, this.itemDetail).then(
    (response) => {
      this.closePopupMethod(true);
      this._notifierService.showUpdateDataSuccess();
      this.onAfterSave();
      this.submitting = false;
    },
    (error) => {
      this._notifierService.showUpdateDataFailed();
      this.submitting = false;
    }
  );
}
}
